export default __webpack_public_path__ + "static/media/yellowHorn.207905e2.svg";